export const AccountQueryName = {
  APPLE_NFC_VAS: 'appleNfcVasPayload',
  CARD_NUMBER: 'cardnum',
  PHONE_NUMBER: 'phonenum',
  EMAIL: 'email',
  FIRST_NAME: 'firstname',
  LAST_NAME: 'lastname',
  FULL_NAME: 'fullname',
};
export const SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS';
export const SEARCH_CUSTOMERS_FULFILLED = 'SEARCH_CUSTOMERS_FULFILLED';
export const SEARCH_CUSTOMERS_REJECTED = 'SEARCH_CUSTOMERS_REJECTED';
export const CLEAR_SEARCH_CUSTOMERS = 'CLEAR_SEARCH_CUSTOMERS';
